import * as config from "../../../config/config";
import { ImageStyled, TextStyled, Wrapper } from "./styles";

export default function CompanyNoResults() {
  return (
    <Wrapper>
      <ImageStyled
        src={
          config.assetDomain +
          "/images/jobseeker-illustrations/hiredly-company-search-empty-placeholder.svg"
        }
      />
      <TextStyled>Sorry, we couldn't find any matching companies.</TextStyled>
    </Wrapper>
  );
}
